<script setup>
import Vue, {ref} from "vue";
import multiselect from "vue-multiselect";
import {getLogo} from "@/helpers/logo";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";
import ecosystemNeedsService from "@/services/ecosystem/ecosystem-needs.service";
import useDebounce from "@/composables/useDebounce";

const {needId} = defineProps(['needId']);
const emit = defineEmits(['startupAdded']);

const debounce = useDebounce();

const showModal = ref(false);
const startupsList = ref([]);
const defaultStartupsList = ref(null);
const loading = ref(false);
const adding = ref(false);
const startup = ref(null);

async function getStartupsList(search = '') {
    debounce(async () => {
        if (search || defaultStartupsList.value === null) {
            loading.value = true;
            const {data} = await ecosystemNeedsService.getStartupsListToAdd(needId, search);

            loading.value = false;
            startupsList.value = [...data];

            if (defaultStartupsList.value === null) {
                defaultStartupsList.value = [...data];
            }
        } else {
            startupsList.value = [...defaultStartupsList.value];
        }
    });
}

async function save() {
    const {data} = await ecosystemNeedsService.addStartup(needId, startup.value.id);

    adding.value = false;
    showModal.value = false;

    if (data) {
        Vue.notify({
            group: 'app',
            type: 'error',
            duration: 5000,
            text: data
        })
    } else {
        defaultStartupsList.value = null;
        emit('startupAdded');
    }
}

function open() {
    showModal.value = true;
    startup.value = null;
    getStartupsList();
}

defineExpose({
    open
});
</script>

<template>
    <div>
        <b-modal v-model="showModal" title="Submit Startup">
            <div class="form">
                <multiselect
                    class="multiselect--complex multiselect-mid"
                    v-model="startup"
                    :options="startupsList"
                    select-label=""
                    deselect-label=""
                    label="name"
                    track-by="name"
                    placeholder="Search startup"
                    @search-change="getStartupsList"
                    :loading="loading"
                >
                    <template slot="option" slot-scope="props">
                        <template v-if="props.option.id === -1">
                            <span class="link-add">Add New Startup</span>
                        </template>

                        <template v-else>
                            <img :src="getLogo(props.option.logo)" style="width:40px" alt=""> {{ props.option.name }}
                        </template>
                    </template>
                </multiselect>
            </div>

            <template #modal-footer>
                <PrimaryButton
                    caption="Add To Need"
                    loadingCaption="Adding Startups..."
                    :disabled="!startup"
                    :loading="adding"
                    @click="save"
                />
            </template>
        </b-modal>
    </div>
</template>

<style scoped>

</style>
